export default {"src":"/pro/_next/static/media/blast.049c34b2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};